// extracted by mini-css-extract-plugin
export default {"container":"ConfirmSessionSwitch_container__vilTm","content":"ConfirmSessionSwitch_content__dKQrQ","message":"ConfirmSessionSwitch_message__pdTal"};